import React from "react";
import styled from "styled-components";

import { Button, FormControl } from "@material-ui/core";
import { isEmpty } from "lodash";

const StyledFormControl = styled(FormControl)`
  margin-top: 2vh;
`;
const StyledButton = styled(Button)`
  background-color: ${(props) => props.theme.palette.yellow.light}!important;
  color: ${(props) => props.theme.palette.primary.dark}!important;
  background-color: ${(props) =>
    props.disabled && props.theme.palette.red.light}!important;
  font-weight: 700 !important;

  margin-top: 2vh;
`;

const Submit = (props) => {
  return (
    <StyledFormControl>
      <StyledButton type="submit" disabled={!props.stripe || props.processing}>
        {props.processing ? "Processing" : "Donate now"}
      </StyledButton>
    </StyledFormControl>
  );
};

export default Submit;
